import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIkonMailsendt({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 449.4 423.6"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M449.4 10.2V7.8c0-.1 0-.3-.1-.4 0-.1 0-.3-.1-.4 0-.1 0-.3-.1-.4 0-.1-.1-.3-.2-.4 0-.1-.1-.2-.2-.4 0-.1-.1-.3-.2-.4 0-.1-.1-.2-.2-.3 0-.2-.2-.3-.3-.5 0 0 0-.1-.1-.2-.1-.2-.3-.3-.4-.5 0 0 0-.1-.2-.2l-.6-.6-.1-.1-.5-.5c-.1 0-.2-.2-.3-.3-.1 0-.2-.2-.4-.3-.1 0-.3-.2-.4-.3-.1 0-.2-.1-.3-.2-.1 0-.3-.2-.4-.2 0 0-.2 0-.3-.1-.1 0-.3-.1-.4-.2-.1 0-.3-.1-.4-.2-.1 0-.3 0-.4-.1-.1 0-.3 0-.4-.1h-5.2c-.1 0-.3 0-.4.1-.2 0-.4.1-.6.2h-.2c-.2 0-.5.2-.7.3L5.5 220.1c-3.5 1.8-5.7 5.5-5.4 9.5.2 4 2.8 7.4 6.5 8.8l126.1 47.5 43.9 131c0 .1.1.3.2.4 0 .1 0 .2.1.3 0 .1.1.2.2.3 0 .1.1.3.2.4 0 0 0 .1.1.2 0 .2.2.3.3.5 0 0 0 .1.1.2.1.2.2.3.4.5l.1.1c.1.2.3.3.4.5l.2.2.4.4.2.2c.1.1.2.2.4.3 0 0 .2.1.3.2.1 0 .2.2.4.3.1 0 .2.1.3.2.1 0 .2.2.4.2.1 0 .2.1.3.2.1 0 .3.1.4.2h.2c.3.1.5.2.8.3h.2l.9.3h.2c.3 0 .5 0 .8.1H187.5c.3 0 .5 0 .8-.1h.3c.3 0 .5-.1.8-.2h.2c.2 0 .4-.2.6-.2.1 0 .2 0 .3-.1.6-.3 1.2-.6 1.8-1.1l.1-.1c.2-.2.4-.4.7-.5l.2-.2.5-.5 77.9-89.2 92.7 34.1c1.1.4 2.3.6 3.5.6 1.7 0 3.4-.4 4.9-1.3 2.5-1.4 4.3-3.9 4.9-6.7L449.2 12c.1-.6.2-1.1.2-1.7v-.1ZM195.2 288.8s-.1.2-.2.2c-.2.2-.3.4-.5.7 0 .1-.2.3-.2.4l-.3.6c0 .1-.1.3-.2.5 0 .2-.2.4-.2.6 0 .2-.1.3-.2.5 0 .2-.1.4-.2.6 0 .2 0 .3-.1.5v.4l-11 76.7-29.9-89.3L345.3 108 195.4 288.8ZM375.7 53.7l-237.4 213-103.7-39.1L375.7 53.7ZM200.6 381.5l10.4-72.7 38.4 14.1 1.8.7-50.6 58Zm159.5-39.2-140.4-51.6L421.4 47.3l-61.3 295Z" />
        </svg>
    )
}
SvgIkonMailsendt.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIkonMailsendt
